import { useEffect, useState } from "react";
import BasicCustomTable from "../../component/basicTable";
import { historyColumns, historyData } from "../../constants/delivery";
import CustomPopupForm from "../../component/customPopupModel";
import { useSelector } from "react-redux";
import { useSnackbar } from "../../component/SnackbarContext";
import axiosInstance from "../../configuration/request";

function TaskHistory() {
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogDetails, setDialogDetails] = useState("");
    const deliveryId = useSelector((state) => state.counter.deliveryPersonId);
  const showSnackbar = useSnackbar();
    const [historyData, setHistoryData] = useState([]);
  

    useEffect(() => {
      fetchHistoryData();
    }, []);
  
   const fetchHistoryData = () => {
    axiosInstance
      .get(`/customer/delivery-person/history/${deliveryId}`)
      .then((res) => {
         const formattedUser = res?.data?.data?.map((item) => ({
            id: item?.id,
            job_id: item?.jobId,
            date: item?.date,
            customer: item?.order?.user?.name,
            location: item?.order?.user_address?.city,
            Earnings:item?.earnings,
            status_tag: item?.status,
            feedbacks:item?.feedbacks,
            score: 4,
            content:"good delivery service"
          }));
        setHistoryData(formattedUser || []);
      })
      .catch((error) => {
        showSnackbar(
          error?.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDialogDetails("");
  };

  const handleView = (row) => {
    setOpenDialog(true);
    setDialogDetails(row);
  };

  return (
    <div className="pt-1 pb-4 pr-6 pl-4 mx-auto  space-y-6">
      <h1 className="text-2xl font-semibold text-[var(--primary-text-color)]">
        Task History
      </h1>

      <BasicCustomTable
        columns={historyColumns}
        rows={historyData}
        colorHeader={true}
        tableName="task_history"
        customClassHeader="table-header-cell-colored"
        maxHeightClass="max-h-[calc(100vh-230px)]"
        frontendPagination={true}
         pageLimit={10}
        onView={handleView}
      />

      <CustomPopupForm
        isOpen={openDialog}
        handleClose={handleCloseDialog}
        dialogType={"review-feedback"}
        dialogDetails={dialogDetails}
      />
    </div>
  );
}

export default TaskHistory;
